import React,{ createContext, useContext, useState, useEffect} from "react";
import axios from "axios";
import { localserver } from "../../api/common";
import { showToast, ToastMessage } from "../Shared/ToastMessage"

const EventContext = createContext(null);

export const EventProvider = ({ children }) => {

    const [eventId, setEventId] = useState(localStorage.getItem('eventId'));
    const [eventName, setEventName] = useState("");
    const [eventStatus, setEventStatus] = useState("");
    const [eventDetailsUrl, setEventDetailsUrl] = useState("");

    const updateEventStatus = async () => {
      try {
        const response = await axios.post(`${localserver}/updateEventstatus`, {
          event_id: eventId,
          event_status: "published"
        }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        });
        if (response.data.success) {
            showToast(response.data.message,"success");
            fetchEventDetails(eventId);
        } else {
          showToast(response.data.message,"error");
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };

    const fetchEventDetails = async (eventId) => {
      try {
        const response = await axios.post(`${localserver}/get_event_details_by_event_id`, {event_id: eventId}, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        });
        if (response.data.success) {
          const details = response.data.event;
          console.log("Event Details:", details);
          setEventName(details.event_name);
          setEventStatus(details.event_status);
          setEventDetailsUrl(details.event_details_url);
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };
    return (
        <EventContext.Provider value={{ eventId, setEventId, eventName, eventStatus, fetchEventDetails, updateEventStatus, eventDetailsUrl }}>
            {children}
        </EventContext.Provider>
    );
};

export const useEvent = () => useContext(EventContext);
